import React from 'react';
import PropTypes from 'prop-types';

const EmailTagDisplay = ({ emailString }) => {
  if (!emailString) {
    return <span className="text-muted">No emails configured.</span>;
  }
  const emails = emailString
    .split(',')
    .map(email => email.trim())
    .filter(email => email.length > 0);

  return (
    <div className="email-display-container">
      {emails.map((email) => (
        <span key={email.id} className="email-display-tag">
          {email}
        </span>
      ))}
    </div>
  );
};

EmailTagDisplay.propTypes = {
  emailString: PropTypes.string
};

export default EmailTagDisplay;